import { render, staticRenderFns } from "./select_lang.vue?vue&type=template&id=49d3a3ae"
import script from "./select_lang.vue?vue&type=script&lang=js"
export * from "./select_lang.vue?vue&type=script&lang=js"
import style0 from "./select_lang.vue?vue&type=style&index=0&id=49d3a3ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports